import { TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { RoleFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function RoleForm() {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<RoleFormSchema>();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<TextInput
				isRequired
				label={t("general.name")}
				control={methods.control}
				name="name"
				placeholder={t("placeholders.role_name")}
			/>
		</div>
	);
}
